import $ from 'jquery';

$('.slide-menu-has-child > a').on('click', function (ev) {
  ev.preventDefault();

  $(this).toggleClass('is-active').next('ul').slideToggle(300);
});
